import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';
import SingleImageTile from '@/components/SingleImageTile/SingleImageTile';

const singleTileImage = (desktopSrc, mobileSrc) => [
  {
    src: mobileSrc,
    size: { width: 736, aspectRatio: 736 / 920 },
    breakpoint: 767,
  },
  {
    src: desktopSrc,
    size: { width: 736, aspectRatio: 736 / 320 },
    breakpoint: 1023,
  },
  {
    src: desktopSrc,
    size: { width: 1376, aspectRatio: 1376 / 600 },
    breakpoint: 2048,
  },
];

export default function SingleImageTileBuilder({
  image,
  mobileImage,
  desktopVideoUri,
  mobileVideoUri,
  altImageText,
  imageLink,
  textOnImage,
  isSetMaxWidth,
  isTextCenter,
  items,
  anchorLinkID,
  margin,
  wistiaVideo,
  desktopVideoSource,
  mobileVideoSource,
  controls,
  loop,
  autoplay,
}) {
  return (
    <SingleImageTile
      imgSrc={singleTileImage(image, mobileImage)}
      videoSrc={desktopVideoUri}
      mobileVideoSrc={mobileVideoUri}
      imgAlt={altImageText}
      imgHref={imageLink}
      textOnImage={textOnImage}
      items={items}
      isSetMaxWidth={isSetMaxWidth}
      isTextCenter={isTextCenter}
      {...getAnchorId(anchorLinkID)}
      className={getComponentMargin(margin)}
      wistiaVideo={wistiaVideo}
      desktopVideoSource={desktopVideoSource}
      mobileVideoSource={mobileVideoSource}
      controls={controls}
      loop={loop}
      autoplay={autoplay}
    />
  );
}
